import {
    Avatar,
    Comment,
    Card,
    Typography,
    Row,
    Col,
    Divider,
    Space,
    Button,
    message,
    Spin,
    Select,
    Switch, Tag, Input, Popconfirm, Modal, Pagination, Upload, Collapse, Timeline
} from "antd";
import {UserDataDtoGenderEnum} from "acc-rest-client";
import React, {useState} from "react";
import moment from "moment/moment";
import {calculate_age} from "../tables/LetterTables";
import {StackDto} from "ps-letter-mgmtrest-client";
import {useDispatch, useSelector} from "react-redux";
import {updateLetter, loadLetter, cancelLetter, downloadLetter, loadLettersByStack, presentToHudhur, reviewLetter, uploadCustomPdf, resetToOriginalAnswerPdf, retryDelivery, loadAttachmentBlob, downloadAttachment, getLetterDownloadHistory} from "../../store/app/app.slice";
import TextArea from "antd/es/input/TextArea";
import {CheckOutlined, CloseOutlined, CodepenCircleFilled, EditOutlined, PlusOutlined, EditFilled, UploadOutlined, UndoOutlined, MailOutlined, SendOutlined, ReloadOutlined} from "@ant-design/icons";
import CreateSummaryDialog from "../dialogs/CreateSummaryDialog";
import {ProcessedLetterDto} from "ps-letter-mgmtrest-client";
import {AnswerDto} from "ps-letter-mgmtrest-client";
import CreateAnswerDialog from "../dialogs/CreateAnswerDialog";
import {getLanguagesLabel, getTopicsLabel, getTopicsLabelUrdu, languages, getCustomUnicodeFlagIcon} from "../helper/labelHelper";
import {getUserProfile} from "../../utils/authHelper";
import maleAvatar from "../../assets/ps-images/gender_male2_icon.png";
import femaleAvatar from "../../assets/ps-images/gender_female_icon.png";
import unknownAvatar from "../../assets/ps-images/unknown-avatar.png";
import EditSenderDialog from "../dialogs/EditSenderDialog";
import { useEffect } from "react";
import {useParams} from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {getCountryLabel} from "../../utils/labelHelper";


const {Title} = Typography;

export default function StackLetter({letter, stack, onLetterProcessed}) {
    const dispatch = useDispatch();
    const params = useParams();
    const {isLetterLoading, isAnswersLoading, summaries, answers} = useSelector((state) => state.app);
    const [showCreateSummaryModal, setShowCreateSummaryDialog] = useState(false);
    const [showUpdateSummaryModal, setShowUpdateSummaryDialog] = useState(false);
    const [showCreateAnswerModal, setShowCreateAnswerDialog] = useState(false);
    const [showUpdateAnswerModal, setShowUpdateAnswerDialog] = useState(false);
    const [showEditSenderModal, setShowEditSenderDialog] = useState(false);
    const [cancelModalVisible, setCancelModalVisible] = useState(false);
    const [cancelComment, setCancelComment] = useState("");
    const [presentToHudhurModalVisible, setPresentToHudhurModalVisible] = useState(false);

    const [summaryId, setSummaryId] = useState(letter?.summary?.id);
    const [showAllSummaries, setShowAllSummaries] = useState(false);
    const [showAllAnswers, setShowAllAnswers] = useState(false);
    const [summaryNotes, setSummaryNotes] = useState(letter?.summaryNotes);
    const [answerId, setAnswerId] = useState(letter?.answer?.id);
    const [customAnswer, setCustomAnswer] = useState(letter?.customAnswer);
    
    // New state for linked answers pagination
    const [linkedAnswersPage, setLinkedAnswersPage] = useState(1);
    const [linkedAnswersPageSize] = useState(1);
    const [hasUserClosedCreateAnswerDialog, setHasUserClosedCreateAnswerDialog] = useState(false);

    // Review state
    const [deliveryMethod] = useState(letter?.deliveryMethod || null);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [isLoadingPdf, setIsLoadingPdf] = useState(false);
    const [downloadEvents, setDownloadEvents] = useState(null);
    const [loadingHistory, setLoadingHistory] = useState(false);
    
    const isReviewMode = stack?.assignedStackType === "REVIEW_ANSWER";

    // Auto-load PDF preview when in review mode
    useEffect(() => {
        if (isReviewMode && letter?.id && letter?.attachmentIdAnswerPdf) {
            if (pdfPreviewUrl) {
                URL.revokeObjectURL(pdfPreviewUrl);
                setPdfPreviewUrl(null);
            }
            setIsLoadingPdf(true);
            dispatch(loadAttachmentBlob({
                finalData: { id: letter.attachmentIdAnswerPdf },
                callbackSuccess: (response) => {
                    const pdfBlob = new Blob([response.data], {type: 'application/pdf'});
                    const url = URL.createObjectURL(pdfBlob);
                    setPdfPreviewUrl(url);
                    setIsLoadingPdf(false);
                },
                callbackError: (error) => {
                    console.error("PDF preview load failed:", error);
                    message.error("Failed to load answer PDF preview");
                    setIsLoadingPdf(false);
                }
            }));
        }
        return () => {
            if (pdfPreviewUrl) {
                URL.revokeObjectURL(pdfPreviewUrl);
            }
        };
    }, [letter?.id, letter?.attachmentIdAnswerPdf]);

    const isUrduLanguage = letter.originalLetter.language === "urdu" || letter.originalLetter.language === "roman_urdu"
    const isUrduRTL = letter.originalLetter.language === "urdu"
    const currentLetterTopic = letter.originalLetter.category
    const currentLetterSummary = letter.summary
    const currentSummary = summaries.find(summary => summary.id === summaryId);
    const currentAnswer = answers.find(answer => answer.id === answerId);

    // Get linked answers for the current summary
    const getLinkedAnswers = () => {
        if (!currentLetterSummary?.id) return [];
        
        return answers.filter(answer => {
            // Check if answer is linked to the current summary
            const isLinkedToSummary = answer.summaries && 
                Array.from(answer.summaries).some(summary => summary.id === currentLetterSummary.id);
            
            // Check if answer is linked to the user
            const isLinkedToUser = answer.createdBy === getUserProfile().sub || 
                (answer.userIds && Array.from(answer.userIds).includes(getUserProfile().sub));
            
            // Check if answer supports the letter language
            const letterLang = letter.originalLetter.language;
            const answerLangs = answer.answerLanguages ? Array.from(answer.answerLanguages) : [];
            const supportsLanguage = answerLangs.includes(letterLang) ||
                (letterLang === "roman_urdu" && answerLangs.includes("urdu"));
            
            return isLinkedToSummary && isLinkedToUser && supportsLanguage;
        });
    };

    const linkedAnswers = getLinkedAnswers();
    const totalLinkedAnswers = linkedAnswers.length;

    // Auto-select random linked answer when available
    useEffect(() => {
        if (linkedAnswers.length > 0 && !answerId && !customAnswer) {
            const randomIndex = Math.floor(Math.random() * linkedAnswers.length);
            setLinkedAnswersPage(randomIndex + 1);
            setAnswerId(linkedAnswers[randomIndex].id);
            setCustomAnswer(null);
        }
    }, [linkedAnswers, answerId, customAnswer]);

    // Reset the dialog close flag when letter changes
    useEffect(() => {
        setHasUserClosedCreateAnswerDialog(false);
    }, [letter.id]);

    // Auto-open create answer dialog when no linked answers exist
    useEffect(() => {
        if (linkedAnswers.length === 0 && !answerId && !customAnswer && 
            (letter?.internalStatus === "LETTER_IN_ANSWER" || letter?.internalStatus === "LETTER_ANSWERED") &&
            !isAnswersLoading && !hasUserClosedCreateAnswerDialog) {
            openCreateAnswerModal();
        }
    }, [linkedAnswers, answerId, customAnswer, letter?.internalStatus, isAnswersLoading, hasUserClosedCreateAnswerDialog]);

    //const [summaryTitle, setSummaryTitle] = useState(letter?.summary?.titleUrdu);
    //const [searchSummary, setSearchSummary] = useState(null);
    // const summaryItems = summaries
    //     .filter(summary => !showAllSummaries ? summary.userIds.includes(getUserProfile().sub) : true)
    //     .filter(summary => searchSummary != null ? summary.titleUrdu.toLowerCase().includes(searchSummary?.toLowerCase()) : true)
    //     .map(summary => {
    //         return {
    //             key: summary.id,
    //             label: summary.createdBy === getUserProfile().sub  ? <span onClick={() => {setSelectedSummary(summary)}} className={"arabic-font arabic-font-edit"}>{summary.titleUrdu}</span> : <><span onClick={() => {setSelectedSummary(summary)}} className={"arabic-font arabic-font-edit"}>{summary.titleUrdu}</span><span className={"shortNotice"}> - ({summary.createdByName.split(" ").map(stringValue => stringValue.substring(0,1)).join("")})</span></>
    //         }
    //     })
    //
    // const setSelectedSummary = (selectedSummary) => {
    //     setSummaryId(selectedSummary.id)
    //     setSummaryTitle(selectedSummary.titleUrdu)
    //     setSearchSummary(null)
    // }
    
    const openCreateSummaryModal = () => {
        setShowCreateSummaryDialog(true);
    };

    const hideCreateSummaryModalModal = () =>  {
        setShowCreateSummaryDialog(false);
    }

    const handleSummaryCreated = (newSummary) => {
        // Auto-select the newly created summary
        setSummaryId(newSummary.id);
    };

    const handleSummaryUpdated = (updatedSummary) => {
        // Refresh the letter data to include the updated summary
        setSummaryId(updatedSummary.id);
    };

    const openUpdateSummaryModal = () => {
        setShowUpdateSummaryDialog(true);
    };

    const hideUpdateSummaryModalModal = () =>  {
        setShowUpdateSummaryDialog(false);
    }

    const openCreateAnswerModal = () => {
        setShowCreateAnswerDialog(true);
        setHasUserClosedCreateAnswerDialog(false);
    };

    const hideCreateAnswerModalModal = () =>  {
        setShowCreateAnswerDialog(false);
        setHasUserClosedCreateAnswerDialog(true);
    }

    const handleAnswerCreated = (newAnswer) => {
        // Auto-select the newly created answer
        setAnswerId(newAnswer.id);
        setCustomAnswer(null);
    };

    const handleAnswerUpdated = (updatedAnswer) => {
        // Auto-select the newly created answer
        setAnswerId(updatedAnswer.id);
        setCustomAnswer(null);
    };

    const openUpdateAnswerModal = () => {
        setShowUpdateAnswerDialog(true);
    };

    const hideUpdateAnswerModalModal = () =>  {
        setShowUpdateAnswerDialog(false);
    }

    const openEditSenderModal = () => {
        setShowEditSenderDialog(true);
    };

    const hideEditSenderModal = () =>  {
        setShowEditSenderDialog(false);
    }
    
    const updateLetterFiltration = (presentToHudhur) => {
        if(presentToHudhur === null || presentToHudhur === undefined)
        {
            onLetterProcessed();      
        }
        else{
            dispatch(updateLetter(
                    {
                        finalData: {
                            id: letter.id,
                            updatedLetter: {
                                id: letter.id,
                                presentToHudhur: presentToHudhur,
                            }
                        },
                        callbackSuccess: (result) => {
                            console.log(result)
                            onLetterProcessed()
                        },
                        callbackError: (error) => {
                            console.log(error)
                            message.error({content: JSON.stringify(error)})
                        },
                    }
                )
            )
        }
        
    }

    const updateLetterSummary = (summaryId, summaryNotes) => {
        //same like filtration
        if(summaryId === null || summaryId === undefined)
        {
            onLetterProcessed();
        }
        else
        {
            dispatch(updateLetter(
                    {
                        finalData: {
                            id: letter.id,
                            updatedLetter: {
                                id: letter.id,
                                summary: {id: summaryId},
                                summaryNotes: summaryNotes
                            }
                        },
                        callbackSuccess: (result) => {
                            console.log(result)
                            onLetterProcessed()
                        },
                        callbackError: (error) => {
                            console.log(error)
                            message.error({content: JSON.stringify(error)})
                        },
                    }
                )
            )
        }
        
    }

    const updateLetterAnswer = (answerId, customAnswer) => {
        //same like filtration
        if((answerId === null || answerId === undefined) && (customAnswer === null || customAnswer === undefined))
        {
            onLetterProcessed();
        }else{
            dispatch(updateLetter(
                    {
                        finalData: {
                            id: letter.id,
                            updatedLetter: {
                                id: letter.id,
                                answer: {id: answerId},
                                customAnswer: customAnswer
                            }
                        },
                        callbackSuccess: (result) => {
                            console.log(result)
                            onLetterProcessed()
                        },
                        callbackError: (error) => {
                            console.log(error)
                            message.error({content: JSON.stringify(error)})
                        },
                    }
                )
            )
        }
        
    }
    
    const getFiltrationControls = () => {
        return <>
            <Spin spinning={isLetterLoading === true}>
                <Row align={"middle"} justify={"space-between"}>
                    <Col span={12} flex={"none"}>
                        <b>Current Value:</b> {letter.presentToHudhur ? <>Present to Huzoor<sup>aa</sup></> : letter.presentToHudhur === false ?  <>Summarize Letter</> : "Not Defined"}
                    </Col>
                    <Col span={12} flex={"none"}>
                            <Button type="default" onClick={() => {updateLetterFiltration(null)}}>Skip</Button>
                    </Col>
                </Row>
            <Divider/>
            <Row align={"middle"} justify={"center"}>
                <Col span={24} flex={"none"}>
                    <Space align={ "center"}>
                    <Button type="primary" onClick={() => {updateLetterFiltration(true)}}>Present to Huzoor<sup>aa</sup></Button>
                    <Button type="default" className={"tag-badge"} onClick={() => {updateLetterFiltration(false)}}>Summarize Letter</Button>
                    </Space>
                </Col>
            </Row>
                </Spin>
        </>
            }

    const getSummaryControls = () => {
        return <>
            <Spin spinning={isLetterLoading === true}>
                <Row align={"middle"} justify={"space-between"}>
                    <Col span={10} flex={"none"}>
                        <b>Current Summary:</b><br/> {letter.summary && currentSummary ? <><span className={"arabic-font-small arabic-font"}>{currentSummary.titleUrdu}</span></> : "Summary not assigned"}
                    </Col>
                    <Col span={14} flex={"none"} style={{textAlign: "right"}}>
                        <Space>
                            {letter.internalStatus !== "LETTER_CANCELLED" &&
                                <Button type="primary" onClick={() => setPresentToHudhurModalVisible(true)} tabIndex={6}>Present Letter to Huzoor<sup>aa</sup></Button>
                            }
                            <Button type="default" onClick={() => {updateLetterSummary(null, null)}} tabIndex={5}>Skip</Button>
                            <Button type="default" className={"ant-tag-success"} onClick={() => {updateLetterSummary(summaryId, summaryNotes)}} tabIndex={3}>Save</Button>
                        </Space>
                    </Col>
                </Row>
                <Divider/>
                <Row align={"middle"} justify={"center"}>
                    <Col span={24} flex={"none"}>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <Select
                                showSearch
                                autoFocus
                                popupClassName={"arabic-font arabic-font-edit"}
                                className={"arabic-font arabic-font-edit"}
                                style={{ width: "2000px" }}
                                size={"large"}
                                placeholder="Select a Summary"
                                optionFilterProp="children"
                                onChange={setSummaryId}
                                //onSearch={onSearch}
                                filterOption={(input, option) =>
                                    ((option?.titleUrdu) ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                fieldNames={{ label: "titleCustom", value: "id"}}
                                options={summaries
                                    .filter(summary => !showAllSummaries && summary.id !== letter?.summary?.id? 
                                        summary.createdBy === getUserProfile().sub || 
                                        summary.userIds.includes(getUserProfile().sub)
                                        : true)
                                    .map(summary => {
                                        return {
                                            ...summary,
                                            titleCustom: summary.createdBy === getUserProfile().sub  ? 
                                                <span className={"arabic-font arabic-font-edit"}>{summary.titleUrdu}</span> : 
                                                <>
                                                    <span className={"arabic-font arabic-font-edit"}>{summary.titleUrdu}</span>
                                                    <span className={"shortNotice"}> - ({summary.createdByName.split(" ").map(stringValue => stringValue.substring(0,1)).join("")})</span>
                                                </>
                                        }
                                    })
                                }
                                value={summaryId}
                                option
                                tabIndex={1}
                            />
                            
                        </div>
                        <div style={{marginTop: "5px", display: "flex", justifyContent: "space-between"}}>
                            <span><Switch checked={showAllSummaries} onChange={setShowAllSummaries} size={"large"} checkedChildren={<>all Summaries <CheckOutlined /></>} unCheckedChildren={<>own Summaries <CheckOutlined /></>} /></span>
                            <span>
                                <Space direction={"horizontal"}>
                                    {currentSummary && currentSummary.createdBy === getUserProfile().sub ?
                                        <Button type="default" className={"ant-tag-blue"} onClick={openUpdateSummaryModal}><EditOutlined/></Button>
                                        :""
                                    }
                                    <Button type="default" className={"ant-tag-green"} onClick={openCreateSummaryModal} tabIndex={4}><PlusOutlined/></Button>        
                                </Space>
                            </span>
                            
                        </div>
                        
                        {/*<div style={{display: "flex", justifyContent: "center"}}>*/}
                        {/*    <Dropdown overlayClassName={"arabic-font arabic-font-edit"}*/}
                        {/*              menu={{items: summaryItems}}*/}
                        {/*              trigger={"click"}*/}
                        {/*              placement={"bottomCenter"}*/}
                        {/*              autoFocus={false}*/}
                        {/*    >*/}
                        {/*        <Input className={"arabic-font arabic-font-edit"}*/}
                        {/*               placeholder={summaryTitle}*/}
                        {/*               value={searchSummary}*/}
                        {/*               onChange={event => {setSearchSummary(event.target.value)}} />*/}
                        {/*    </Dropdown>*/}
                        {/*</div>*/}
                        
                        
                        <br/>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <h3>Additional Notes for Huzoor</h3>
                        </div>
                        <div style={{display: "flex", flexFlow: "column", justifyContent: "center"}}>
                            <ReactQuill
                            className={"arabic-font arabic-font-edit"}
                                value={summaryNotes}
                                onChange={setSummaryNotes}
                                modules={{
                                    toolbar: [
                                        ['bold', 'underline']
                                    ],
                                    keyboard: { bindings: { tab: true } }

                                }}
                                style={{marginBottom: '20px', width: '100%'}}
                                tabIndex={2}
                            />

                            

                        </div>
                    </Col>
                </Row>
                <CreateSummaryDialog showModal={showCreateSummaryModal} onHideModal={hideCreateSummaryModalModal} topic={currentLetterTopic} onSummaryCreated={handleSummaryCreated} onSummaryUpdated={handleSummaryUpdated}/>
                <CreateSummaryDialog key={currentSummary?.id} showModal={showUpdateSummaryModal} onHideModal={hideUpdateSummaryModalModal} summary={currentSummary} onSummaryUpdated={handleSummaryUpdated}/>
            </Spin>
        </>
    }

    const getAnswerControls = () => {
        return <>
            <Spin spinning={isLetterLoading === true}>
                <Row align={"middle"} justify={"space-between"}>
                    <Col span={18} flex={"none"}>
                        <b>Current Answer:</b><br/> {letter.customAnswer ? "Customized Answer" :  letter.answer ? isUrduLanguage ? <><span className={"arabic-font-small arabic-font"}>{currentAnswer?.titleEnglish}</span></> : currentAnswer?.titleEnglish : "Answer not assigned"}
                    </Col>
                    <Col span={6} flex={"none"}>
                        <Button type="default" onClick={() => {updateLetterAnswer(null, null)}} tabIndex={4}>Skip</Button>
                        <Button type="default" className={"ant-tag-success"} onClick={() => {updateLetterAnswer(answerId, customAnswer)}} tabIndex={3}>Save</Button>
                    </Col>
                </Row>
                <Divider/>
                <Row align={"middle"} justify={"center"}>
                    <Col span={24} flex={"none"}>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <Select
                                showSearch
                                autoFocus
                                style={{ width: "2000px" }}
                                popupClassName={isUrduLanguage ? "arabic-font arabic-font-edit" : "arabic-font arabic-font-edit"}
                                className={isUrduLanguage ? "arabic-font arabic-font-edit": "arabic-font arabic-font-edit"}
                                size={"large"}
                                placeholder="Select a Answer"
                                optionFilterProp="children"
                                onChange={(value) => {
                                    setCustomAnswer(null)
                                    setAnswerId(value)}
                                }
                                //onSearch={onSearch}
                                filterOption={(input, option) =>
                                    (option?.titleEnglish).toLowerCase().includes(input.toLowerCase())
                                }
                                fieldNames={{ label: "titleCustom", value: "id"}}
                                options={answers
                                    .filter(answer => !showAllAnswers && answer.id !== letter?.answer?.id ?
                                        (answer.createdBy === getUserProfile().sub ||
                                        answer.userIds.includes(getUserProfile().sub)) && 
                                        (answer.answerLanguages?.includes(letter.originalLetter.language) || (letter.originalLetter.language === "roman_urdu" && answer.answerLanguages?.includes("urdu")))
                                        : (answer.answerLanguages?.includes(letter.originalLetter.language) || (letter.originalLetter.language === "roman_urdu" && answer.answerLanguages?.includes("urdu"))) || answer.id === letter?.answer?.id)
                                    .map(answer => {
                                        return {
                                            ...answer,
                                            titleCustom: answer.createdBy === getUserProfile().sub  ?
                                                <span className={isUrduLanguage ? "arabic-font arabic-font-edit" : "arabic-font arabic-font-edit"}>{answer.titleEnglish}</span> :
                                                <>
                                                    <span className={isUrduLanguage ? "arabic-font arabic-font-edit" : "arabic-font arabic-font-edit"}>{answer.titleEnglish}</span>
                                                    <span className={"shortNotice"}> - ({answer.createdByName.split(" ").map(stringValue => stringValue.substring(0,1)).join("")})</span>
                                                </>
                                        }
                                    })
                                }
                                
                                value={answerId}
                                option
                                tabIndex={1}
                            />
                        </div>

                        <div style={{marginTop: "5px", display: "flex", justifyContent: "space-between"}}>
                            <span><Switch checked={showAllAnswers} onChange={setShowAllAnswers} size={"large"} checkedChildren={<>all Answers <CheckOutlined /></>} unCheckedChildren={<>own Answers <CheckOutlined /></>} /></span>
                            <span>
                                <Space direction={"horizontal"}>
                                    {currentAnswer && currentAnswer.createdBy === getUserProfile().sub ?
                                        <Button type="default" className={"ant-tag-blue"} onClick={openUpdateAnswerModal}><EditOutlined/></Button>
                                        :""
                                    }
                                    <Button type="default" className={"ant-tag-green"} onClick={openCreateAnswerModal}><PlusOutlined/></Button>
                                </Space>
                            </span>

                        </div>
                        
                        
                        <br/>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <h3>Answer</h3>
                        </div>
                        <div style={{display: "flex", flexFlow: "column", justifyContent: "center"}}>
                            <ReactQuill
                                className={getTextClass()}
                                value={getCurrentAnswer()}
                                onChange={setCustomAnswer}
                                modules={{
                                    toolbar: [
                                        ['bold', 'underline']
                                    ],
                                    keyboard: { bindings: { tab: true } }
                            }}
                            style={{marginBottom: '20px', width: '100%'}}
                            tabIndex={2}
                        />
                        </div>
                        
                        <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}><b>Additional Summary Notes:</b> <span className="arabic-font arabic-font-edit" dangerouslySetInnerHTML={{ __html: (letter.summaryNotes && letter.summaryNotes.trim() ? letter.summaryNotes : "No additional notes").replace(/<p>/g, '<span class="arabic-font arabic-font-edit">').replace(/<\/p>/g, '</span>') }}></span></p>
                        
                        {renderComments()}
                        
                        <div style={{display: "flex", flexFlow: "column", justifyContent: "center"}}>
                        {/* Show linked answers pagination if available */}
                        {totalLinkedAnswers > 0 && !showAllAnswers && (
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px", gap: "10px"}}>
                                <Pagination
                                    simple
                                    current={linkedAnswersPage}
                                    total={totalLinkedAnswers}
                                    pageSize={linkedAnswersPageSize}
                                    onChange={(page) => {
                                        setLinkedAnswersPage(page);
                                        setAnswerId(linkedAnswers[page - 1].id);
                                        setCustomAnswer(null);
                                    }}
                                />
                                <Button 
                                    type="default" 
                                    onClick={() => {
                                        const randomIndex = Math.floor(Math.random() * linkedAnswers.length);
                                        setLinkedAnswersPage(randomIndex + 1);
                                        setAnswerId(linkedAnswers[randomIndex].id);
                                        setCustomAnswer(null);
                                    }}
                                >
                                    Random Answer
                                </Button>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            <CreateAnswerDialog 
                key={currentSummary ? `${currentSummary.titleUrdu || 'No Title'} - ${getLinkedAnswers().length + 1}` : ""}
                showModal={showCreateAnswerModal} 
                onHideModal={hideCreateAnswerModalModal} 
                letterLanguage={letter.originalLetter.language} 
                isUrduLanguage={isUrduLanguage} 
                topic={currentLetterTopic} 
                summary={currentLetterSummary?.id}
                defaultTitle={currentSummary ? `${currentSummary.titleUrdu || 'No Title'} - ${getLinkedAnswers().length + 1}` : ""}
                onAnswerCreated={handleAnswerCreated}
                onAnswerUpdated={handleAnswerUpdated}
            />
            <CreateAnswerDialog key={currentAnswer?.id} showModal={showUpdateAnswerModal} onHideModal={hideUpdateAnswerModalModal} isUrduLanguage={isUrduLanguage} answer={currentAnswer} onAnswerUpdated={handleAnswerUpdated}/>
        </Spin>
    </>
    }
    
    const getCurrentAnswer = () => {
        if(customAnswer !== null && customAnswer !== undefined)
            return customAnswer;
        if(answerId !== null && answerId !== undefined)
        {
            const selectedAnswer = answers.find(answer => answer.id === answerId);
            switch(letter?.originalLetter?.language)
            {
                // case "urdu":
                // case "roman_urdu":
                //     return selectedAnswer?.answerUrdu
                // case "deutsch":
                //     return selectedAnswer?.answerGerman
                default:
                    return selectedAnswer?.answerEnglish;
            }    
        }
        return null
    }

    const getTextClass = () => {
        if(isUrduLanguage) return "arabic-font arabic-font-edit";
        return "";
    }

    const renderComments = () => {
        if (!letter.comments || letter.comments.length === 0) return null;
        
        return (
            <>
                <p style={{ marginBottom: '8px' }}><b>Comments:</b></p>
                {letter.comments.map((comment, index) => (
                    <div key={index} style={{ marginBottom: '12px', padding: '8px', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                        <p style={{ margin: '0 0 4px 0' }}><b>Type:</b> {comment.subject || "Unknown"}</p>
                        <p style={{ margin: '0 0 4px 0' }}><b>Note:</b> {comment.commentText || "No text provided"}</p>
                        <p style={{ margin: '0 0 4px 0', color: 'grey' }}><b>By:</b> {comment.commenterName || "Unknown"}</p>
                        {comment.commentDateTime && (
                            <p style={{ margin: '0', color: 'grey' }}><b>Date:</b> {moment.utc(comment.commentDateTime).format("DD-MM-yyyy HH:mm (UTC)")}</p>
                        )}
                    </div>
                ))}
            </>
        );
    }

    const handleReviewLetter = (reviewStatus, method) => {
        const resolvedMethod = method || (reviewStatus === "ACCEPTED" ? deliveryMethod : null);
        const reviewDto = {
            reviewStatus: reviewStatus,
            deliveryMethod: resolvedMethod
        };

        dispatch(reviewLetter({
            finalData: { letterId: letter.id, reviewDto: reviewDto },
            callbackSuccess: (result) => {
                console.log("Review successful", result);
                message.success("Letter review saved");
                onLetterProcessed();
            },
            callbackError: (error) => {
                console.log(error);
                message.error({content: JSON.stringify(error)});
            }
        }));
    };

    const handleCustomPdfUpload = (file) => {
        if (file.type !== 'application/pdf') {
            message.error('Only PDF files are accepted');
            return false;
        }

        dispatch(uploadCustomPdf({
            finalData: { letterId: letter.id, file: file },
            callbackSuccess: () => {
                message.success("Custom PDF uploaded and letter marked as replaced");
                dispatch(loadLettersByStack({finalData: {stackId: params?.stackId}}));
            },
            callbackError: (error) => {
                console.log(error);
                message.error({content: JSON.stringify(error)});
            }
        }));
        return false; // Prevent default upload behavior
    };

    const handleResetToOriginalPdf = () => {
        dispatch(resetToOriginalAnswerPdf({
            finalData: { letterId: letter.id },
            callbackSuccess: () => {
                message.success("Reset to original answer PDF");
                dispatch(loadLettersByStack({finalData: {stackId: params?.stackId}}));
            },
            callbackError: (error) => {
                console.log(error);
                message.error("Reset failed: " + error);
            }
        }));
    };

    const isCustomPdfUploaded = letter.attachmentIdAnswerPdf && letter.attachmentIdAnswerPdfOriginal
        && letter.attachmentIdAnswerPdf !== letter.attachmentIdAnswerPdfOriginal;

    const handleRetryDelivery = (newDeliveryMethod) => {
        dispatch(retryDelivery({
            finalData: { letterId: letter.id, deliveryMethod: newDeliveryMethod || undefined },
            callbackSuccess: (response) => {
                message.success('Delivery retry initiated');
                dispatch(loadLettersByStack({finalData: {stackId: params?.stackId}}));
                dispatch(loadLetter({finalData: {id: letter.id}}));
                if (newDeliveryMethod === "POST" && letter.attachmentIdAnswerPdf) {
                    dispatch(downloadAttachment({
                        finalData: {id: letter.attachmentIdAnswerPdf},
                        callbackSuccess: () => {
                            message.success('Answer PDF download started');
                        },
                        callbackError: (error) => {
                            message.error('Failed to download Answer PDF: ' + error);
                        }
                    }));
                }
            },
            callbackError: (error) => {
                message.error('Delivery retry failed: ' + error);
            }
        }));
    };

    const ANSWER_EVENT_META = {
        ANSWER_AVAILABLE:   { label: 'Notified available', color: 'blue' },
        DOWNLOAD_REQUESTED: { label: 'Download requested', color: 'gold' },
        PDF_PUSHED:         { label: 'PDF prepared', color: 'geekblue' },
        DOWNLOAD_COMPLETED: { label: 'Downloaded', color: 'green' },
        TRANSFER_FAILED:    { label: 'Transfer failed', color: 'red' },
        DOWNLOAD_REVOKED:   { label: 'Download revoked (post)', color: 'volcano' },
    };

    const timelineColor = (eventType) => {
        if (eventType === 'DOWNLOAD_COMPLETED') return 'green';
        if (eventType === 'TRANSFER_FAILED' || eventType === 'DOWNLOAD_REVOKED') return 'red';
        return 'blue';
    };

    const loadDownloadHistory = () => {
        setLoadingHistory(true);
        dispatch(getLetterDownloadHistory({
            letterId: letter.id,
            callbackSuccess: (data) => { setDownloadEvents(data || []); setLoadingHistory(false); },
            callbackError: () => { setDownloadEvents([]); setLoadingHistory(false); }
        }));
    };

    const renderDownloadHistory = () => (
        <Collapse ghost onChange={(keys) => { if (keys.length && downloadEvents === null && !loadingHistory) loadDownloadHistory(); }}>
            <Collapse.Panel header="Download history" key="history">
                <Spin spinning={loadingHistory}>
                    {downloadEvents && downloadEvents.length > 0 ? (
                        <>
                            <p style={{ marginBottom: 8 }}>
                                <b>Downloads:</b> {downloadEvents.filter(e => e.eventType === 'DOWNLOAD_COMPLETED').length}
                            </p>
                            <Timeline>
                                {[...downloadEvents].sort((a, b) => (b.id ?? 0) - (a.id ?? 0)).map((ev) => {
                                    const meta = ANSWER_EVENT_META[ev.eventType] || { label: ev.eventType, color: 'default' };
                                    return (
                                        <Timeline.Item key={ev.id} color={timelineColor(ev.eventType)}>
                                            <Tag color={meta.color}>{meta.label}</Tag>
                                            {ev.occurredAt && <span style={{ color: 'grey' }}> {moment.utc(ev.occurredAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                                            {ev.detail && <div style={{ color: 'grey', fontSize: 12 }}>{ev.detail}</div>}
                                        </Timeline.Item>
                                    );
                                })}
                            </Timeline>
                        </>
                    ) : (
                        !loadingHistory && <span style={{ color: 'grey' }}>No download activity yet.</span>
                    )}
                </Spin>
            </Collapse.Panel>
        </Collapse>
    );

    const getDeliveryFailedControls = () => {
        return <>
            <Spin spinning={isLetterLoading === true}>
                <Row align={"middle"} justify={"space-between"} style={{marginBottom: "12px"}}>
                    <Col>
                        <Tag color="red">Delivery Failed</Tag>
                        {letter.deliveryMethod && <Tag color={letter.deliveryMethod === "EMAIL" ? "green" : "blue"}>{letter.deliveryMethod === "EMAIL" ? "Email" : "Post"}</Tag>}
                    </Col>
                    <Col>
                        <Space wrap>
                            {/* Only for e-mail. Once the letter is switched to post the
                                staff handle it by hand, so there is nothing left for the
                                system to retry. */}
                            {letter.deliveryMethod === "EMAIL" && (
                                <Popconfirm title="Retry delivery via Email?" onConfirm={() => handleRetryDelivery(null)} okText="Yes" cancelText="No">
                                    <Button type="primary" size="small" icon={<ReloadOutlined />}>
                                        Retry Delivery
                                    </Button>
                                </Popconfirm>
                            )}
                            {letter.deliveryMethod === "EMAIL" && (
                                <Popconfirm title="Change delivery method to Post!" onConfirm={() => handleRetryDelivery("POST")} okText="Yes" cancelText="No">
                                    <Button type="primary" size="small" icon={<SendOutlined />}>
                                        Change to Post
                                    </Button>
                                </Popconfirm>
                            )}
                        </Space>
                    </Col>
                </Row>

                {/* Context info */}
                <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <b>Answer:</b> {letter.customAnswer ? "Customized Answer" : letter.answer ? currentAnswer?.titleEnglish : "Not assigned"}
                </p>
                <p style={{ marginTop: '-8px' }}>
                    <span style={{ color: 'grey' }}>Answered by: {letter.answerByName || "N/A"}</span>
                    {letter.answerAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.answerAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                </p>
                {letter.reviewedByName && (
                    <p style={{ marginTop: '-8px' }}>
                        <span style={{ color: 'grey' }}>Reviewed by: {letter.reviewedByName}</span>
                        {letter.reviewedAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.reviewedAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                    </p>
                )}
                {renderDownloadHistory()}
                {renderComments()}
            </Spin>
        </>
    };

    const getDeliveredControls = () => {
        return <>
            <Spin spinning={isLetterLoading === true}>
                <Row align={"middle"} justify={"space-between"} style={{marginBottom: "12px"}}>
                    <Col>
                        <Tag color="blue">Answer Delivered</Tag>
                        {letter.deliveryMethod && <Tag color={letter.deliveryMethod === "EMAIL" ? "green" : "blue"}>{letter.deliveryMethod === "EMAIL" ? "Email" : "Post"}</Tag>}
                    </Col>
                    <Col>
                        <Space wrap>
                            {letter.deliveryMethod === "EMAIL" && (
                                <Popconfirm title="Notify again via Email?" onConfirm={() => handleRetryDelivery(null)} okText="Yes" cancelText="No">
                                    <Button type="primary" size="small" icon={<MailOutlined />}>
                                        Notify again
                                    </Button>
                                </Popconfirm>
                            )}
                            {letter.deliveryMethod === "EMAIL" && (
                                <Popconfirm title="Change delivery method to Post?" onConfirm={() => handleRetryDelivery("POST")} okText="Yes" cancelText="No">
                                    <Button type="primary" size="small" icon={<SendOutlined />}>
                                        Send via Post
                                    </Button>
                                </Popconfirm>
                            )}
                        </Space>
                    </Col>
                </Row>

                {/* Context info */}
                <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <b>Answer:</b> {letter.customAnswer ? "Customized Answer" : letter.answer ? currentAnswer?.titleEnglish : "Not assigned"}
                </p>
                <p style={{ marginTop: '-8px' }}>
                    <span style={{ color: 'grey' }}>Answered by: {letter.answerByName || "N/A"}</span>
                    {letter.answerAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.answerAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                </p>
                {letter.reviewedByName && (
                    <p style={{ marginTop: '-8px' }}>
                        <span style={{ color: 'grey' }}>Reviewed by: {letter.reviewedByName}</span>
                        {letter.reviewedAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.reviewedAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                    </p>
                )}
                {renderDownloadHistory()}
                {renderComments()}
            </Spin>
        </>
    };

    const getReviewControls = () => {
        return <>
            <Spin spinning={isLoadingPdf || isLetterLoading === true}>
                {/* Header row: status + action buttons on one line */}
                <Row align={"middle"} justify={"space-between"} style={{marginBottom: "12px"}}>
                    <Col>
                        <b>Review Status:</b> {letter.reviewStatus ? <Tag color={letter.reviewStatus === "ACCEPTED" ? "green" : letter.reviewStatus === "REPLACED" ? "blue" : letter.reviewStatus === "SKIPPED" ? "orange" : "default"}>{letter.reviewStatus}</Tag> : "Pending Review"}
                        {letter.deliveryMethod && <Tag color="purple">{letter.deliveryMethod}</Tag>}
                        {letter.reviewStatus === "REPLACED" && !letter.deliveryMethod && (
                            <Tag color="red">Choose Email or Post</Tag>
                        )}
                    </Col>
                    <Col>
                        <Space wrap>
                            <Button type="primary" size="small" style={{backgroundColor: "#52c41a", borderColor: "#52c41a"}} icon={<MailOutlined />} onClick={() => handleReviewLetter("ACCEPTED", "EMAIL")}>
                                Accept (Email)
                            </Button>
                            <Button type="primary" size="small" icon={<SendOutlined />} onClick={() => handleReviewLetter("ACCEPTED", "POST")}>
                                Accept (Post)
                            </Button>
                            <Upload accept=".pdf" showUploadList={false} beforeUpload={handleCustomPdfUpload}>
                                <Button danger size="small" icon={<UploadOutlined />}>
                                    Upload Custom PDF
                                </Button>
                            </Upload>
                            {isCustomPdfUploaded && (
                                <Popconfirm title="Reset to original PDF?" onConfirm={handleResetToOriginalPdf} okText="Yes" cancelText="No">
                                    <Button type="default" size="small" icon={<UndoOutlined />}>
                                        Reset to Original
                                    </Button>
                                </Popconfirm>
                            )}
                            <Button type="default" size="small" onClick={() => handleReviewLetter("SKIPPED")}>
                                Skip
                            </Button>
                        </Space>
                    </Col>
                </Row>

                {/* PDF Preview */}
                {pdfPreviewUrl ? (
                    <div style={{border: "1px solid #d9d9d9", borderRadius: "4px", marginBottom: "12px", height: "calc(100vh - 420px)", minHeight: "300px"}}>
                        <iframe
                            src={pdfPreviewUrl}
                            style={{width: "100%", height: "100%", border: "none"}}
                            title="Answer PDF Preview"
                        />
                    </div>
                ) : (
                    <div style={{border: "1px solid #d9d9d9", borderRadius: "4px", marginBottom: "12px", height: "200px", display: "flex", justifyContent: "center", alignItems: "center", color: "#999"}}>
                        {isLoadingPdf ? "Loading PDF..." : "PDF preview not available"}
                    </div>
                )}

                {/* Context info */}
                <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <b>Summary:</b> {letter.summary ? <span className={"arabic-font-small arabic-font"}>{currentSummary?.titleUrdu}</span> : "Not assigned"}
                </p>
                <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <b>Answer:</b> {letter.customAnswer ? "Customized Answer" : letter.answer ? currentAnswer?.titleEnglish : "Not assigned"}
                </p>
                <p style={{ marginTop: '-8px' }}>
                    <span style={{ color: 'grey' }}>Answered by: {letter.answerByName || "N/A"}</span>
                    {letter.answerAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.answerAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                </p>
                {letter.reviewedByName && (
                    <p style={{ marginTop: '-8px' }}>
                        <span style={{ color: 'grey' }}>Reviewed by: {letter.reviewedByName}</span>
                        {letter.reviewedAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.reviewedAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                    </p>
                )}
                {letter.modifiedAnswerPdfUploadedByName && (
                    <p style={{ marginTop: '-8px' }}>
                        <span style={{ color: 'grey' }}>Custom PDF uploaded by: {letter.modifiedAnswerPdfUploadedByName}</span>
                        {letter.modifiedAnswerPdfUploadedAt && <span style={{ color: 'grey' }}> on {moment.utc(letter.modifiedAnswerPdfUploadedAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}
                    </p>
                )}
                {renderComments()}
            </Spin>
        </>
    };

    const getStackControls = () => {

        switch (stack?.assignedStackType) {
            case"FILTRATION":
                switch (letter?.internalStatus) {
                    case "LETTER_IN_FILTRATION":
                    case "LETTER_FILTERED":
                        return getFiltrationControls()
                    default:
                        return getLetterInfo()
                }
            case"SUMMARY":
                switch (letter?.internalStatus) {
                    case "LETTER_IN_SUMMARY":
                    case "LETTER_SUMMARIZED":
                        return getSummaryControls()
                    default:
                        return getLetterInfo()
                }
            case"ANSWER":
                switch (letter?.internalStatus) {
                    case "LETTER_IN_ANSWER":
                    case "LETTER_ANSWERED":
                        return getAnswerControls()
                    default:
                        return getLetterInfo()
                }
            case"REVIEW_ANSWER":
                switch (letter?.internalStatus) {
                    case "LETTER_ANSWER_IN_REVIEW":
                    case "LETTER_ANSWER_REVIEWED":
                        return getReviewControls()
                    case "LETTER_ANSWER_DELIVERED":
                        return getDeliveredControls()
                    case "LETTER_ANSWER_DELIVERY_FAILED":
                        return getDeliveryFailedControls()
                    default:
                        return getLetterInfo()
                }
            default:
                return getLetterInfo()
        }
    }

    const handleMoveToSummary = (record) => {
        dispatch(updateLetter(
            {
                finalData: {
                    id: record.id,
                    updatedLetter: {
                        id: record.id,
                        internalStatus: "LETTER_READY_FOR_SUMMARY"
                    }
                },
                callbackSuccess: (result) => {
                    console.log(result)
                    dispatch(loadLetter({finalData: {id: record.id}}))
                },
                callbackError: (error) => {
                    console.log(error)
                    message.error({content: JSON.stringify(error)})
                },
            }
        ))
    }

    const getLetterInfo = () => {
        return <>
            <Spin spinning={isLetterLoading === true}>
                <Row align={"middle"} justify={"space-between"}>
                    <Col span={24}>
                        <h3>Letter Information</h3>
                        <Divider/>
                        <p style={{ display: 'flex', alignItems: 'center', gap: '8px',marginBottom: '4px' }}><b>Present to Huzoor<sup>aa</sup>:</b> {letter.internalStatus === "LETTER_PRESENTED_TO_HUDHUR" ? (
                            <Popconfirm
                                title="Are you sure you want to move this letter to summary?"
                                onConfirm={() => handleMoveToSummary(letter)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <div style={{
                                    backgroundColor: '#f0f0f0',
                                    color: letter.presentToHudhur ? 'green' : letter.presentToHudhur === false ? 'red' : 'grey',
                                    borderRadius: '30%',
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}>
                                    {letter.presentToHudhur ? '✓' : letter.presentToHudhur === false ? '❌' : ''}
                                </div>
                            </Popconfirm>
                        ) : (
                            <div style={{
                                backgroundColor: '#f0f0f0',
                                color: letter.presentToHudhur ? 'green' : letter.presentToHudhur === false ? 'red' : 'grey',
                                borderRadius: '30%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}>
                                {letter.presentToHudhur ? '✓' : letter.presentToHudhur === false ? '❌' : ''}
                            </div>
                        )}</p>
                        <p style={{ marginTop: '-8px' }}><span style={{ color: 'grey' }}>Filtered by: {letter.filteredByName || "Not filtered yet"}</span> {letter.filteredAt && <span style={{ color: 'grey' }}>on {moment.utc(letter.filteredAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}</p>
                        <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}><b>Summary:</b> {letter.summary ? <><span className={"arabic-font-small arabic-font"}>{currentSummary?.titleUrdu}</span></> : "Not assigned"}</p>
                        <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', marginTop: '-8px' }}><b>Notes:</b> <span dangerouslySetInnerHTML={{ __html: (letter.summaryNotes || "None").replace(/<p>/g, '<span class="arabic-font arabic-font-edit">').replace(/<\/p>/g, '</span>') }}></span></p>

                        <p style={{ marginTop: '-8px' }}><span style={{ color: 'grey' }}>Summarized by: {letter.summaryByName || "Not summarized yet"}</span> {letter.summaryAt && <span style={{ color: 'grey' }}>on {moment.utc(letter.summaryAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}</p>
                        <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}><b>Answer:</b> {letter.customAnswer ? "Customized Answer" : letter.answer ? isUrduLanguage ? <><span className={"arabic-font-small arabic-font"}>{currentAnswer?.titleEnglish}</span></> : currentAnswer?.titleEnglish : "Not assigned"}</p>
                        {letter.customAnswer && <p style={{ marginTop: '-8px' }}><span style={{ color: 'grey' }}>Custom Answer: {letter.customAnswer}</span></p>}
                        <p style={{ marginTop: '-8px' }}><span style={{ color: 'grey' }}>Answered by: {letter.answerByName || "Not answered yet"}</span> {letter.answerAt && <span style={{ color: 'grey' }}>on {moment.utc(letter.answerAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}</p>
                        {letter.reviewStatus && (
                            <p style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}><b>Review Status:</b> <Tag color={letter.reviewStatus === "ACCEPTED" ? "green" : letter.reviewStatus === "REPLACED" ? "blue" : letter.reviewStatus === "SKIPPED" ? "orange" : "default"}>{letter.reviewStatus}</Tag>
                                {letter.deliveryMethod && <Tag color={letter.deliveryMethod === "EMAIL" ? "green" : "blue"}>{letter.deliveryMethod === "EMAIL" ? "Email" : "Post"}</Tag>}
                                {letter.attachmentIdAnswerPdf && letter.attachmentIdAnswerPdfOriginal && letter.attachmentIdAnswerPdf !== letter.attachmentIdAnswerPdfOriginal && <Tag color="purple">Custom PDF</Tag>}
                            </p>
                        )}
                        {letter.reviewedByName && (
                            <p style={{ marginTop: '-8px' }}><span style={{ color: 'grey' }}>Reviewed by: {letter.reviewedByName}</span> {letter.reviewedAt && <span style={{ color: 'grey' }}>on {moment.utc(letter.reviewedAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}</p>
                        )}
                        {letter.modifiedAnswerPdfUploadedByName && (
                            <p style={{ marginTop: '-8px' }}><span style={{ color: 'grey' }}>Custom PDF uploaded by: {letter.modifiedAnswerPdfUploadedByName}</span> {letter.modifiedAnswerPdfUploadedAt && <span style={{ color: 'grey' }}>on {moment.utc(letter.modifiedAnswerPdfUploadedAt).format("DD-MM-yyyy HH:mm (UTC)")}</span>}</p>
                        )}
                        {renderDownloadHistory()}
                        {renderComments()}
                    </Col>
                </Row>
            </Spin>
        </>
    }

    const onSenderUpdateDone = () => {
        return dispatch(loadLetter({finalData: {id: letter.id}}))
    }   
    
    /**
     * The letter as a Word file, saved to the browser's downloads.
     *
     * Resolves either way: a letter that could not be rendered must not stop
     * it being cancelled.
     */
    const downloadLetterDocument = () => new Promise((resolve) => {
        dispatch(downloadLetter({
            finalData: { id: letter.id },
            callbackSuccess: (response) => {
                const contentDisposition = response.headers["content-disposition"];
                const filename = contentDisposition
                    ? contentDisposition.split("=")[1]
                    : `letter-${letter.id}.docx`;
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                resolve();
            },
            callbackError: (error) => {
                message.warning('Letter was cancelled, but the Word file could not be downloaded: ' + error);
                resolve();
            }
        }));
    });

    const handleCancelLetter = async () => {
        // Cancelling is how a letter leaves the process -- often to be handed
        // to another department -- so the Word file goes out with it. Taken
        // before the cancellation, because afterwards the letter drops out of
        // the stack and this view is gone.
        await downloadLetterDocument();

        dispatch(cancelLetter({
            finalData: { id: letter.id, comment: { commentText: cancelComment } },
            callbackSuccess: () => {
                setCancelModalVisible(false);
                setCancelComment("");
                if(onLetterProcessed)
                {
                    dispatch(loadLettersByStack({finalData: {stackId: params?.stackId}}))
                    onLetterProcessed();
                }
                else
                {
                    dispatch(loadLetter({finalData: {id: letter.id}}));
                }
            },
            callbackError: (error) => {
                message.error({content: JSON.stringify(error)});
                setCancelModalVisible(false);
            }
        }));
    };

    const handlePresentToHudhur = () => {
        dispatch(presentToHudhur({
            finalData: { id: letter.id },
            callbackSuccess: () => {
                setPresentToHudhurModalVisible(false);
                message.success(<span>Letter moved to Present to Huzoor<sup>aa</sup>&nbsp;</span>);
                if(onLetterProcessed)
                {
                    dispatch(loadLettersByStack({finalData: {stackId: params?.stackId}}))
                    onLetterProcessed();
                }
                else
                {
                    dispatch(loadLetter({finalData: {id: letter.id}}));
                }
            },
            callbackError: (error) => {
                message.error({content: JSON.stringify(error)});
                setPresentToHudhurModalVisible(false);
            }
        }));
    };
    
    return <>
        <Row justify={"start"} style={{height: "100%"}}>
            <Col span={12}>
                <div style={{height: "100%"}}>
                    <Card style={{height: "100%", position: "relative"}}>
                        <Comment
                            content={<>
                                <div>
                                    <Row>
                                        <Col span={16}>
                                            <Avatar.Group>
                                                <div style={{marginRight: "3px"}}>
                                                    <Avatar
                                                        src={letter.originalLetter.sender.gender ? letter.originalLetter.sender.gender === UserDataDtoGenderEnum.Male ? maleAvatar : letter.originalLetter.sender.gender === UserDataDtoGenderEnum.Female ? femaleAvatar : unknownAvatar : unknownAvatar}
                                                        shape="square"
                                                        size="large">{letter.originalLetter.sender.gender}</Avatar>
                                                </div>
                                                <div className="avatar-info">
                                                    <Title
                                                        level={5}>{letter.originalLetter.sender.firstName + " " + letter.originalLetter.sender.lastName} ({calculate_age(letter.originalLetter.sender.birthdate)}){ letter.originalLetter.sender.urduName ? <span className={"arabic-font arabic-font-edit"}> - {letter.originalLetter.sender.urduName}</span> : "" } </Title>
                                                    <p>
                                                        <span>{getCustomUnicodeFlagIcon(letter.originalLetter.sender.country?.values?.flag)} {letter.originalLetter.sender.country ? letter.originalLetter.sender.country.defaultLabel : ""} </span>{letter.originalLetter.sender.jamaat ? "(" + letter.originalLetter.sender.jamaat + ")" : "no jamaat"}
                                                    </p>
                                                </div>
                                            </Avatar.Group>
                                            {(letter.internalStatus === "LETTER_RECEIVED" || letter.internalStatus === "LETTER_IN_FILTRATION" || letter.internalStatus === "LETTER_FILTERED" || letter.internalStatus === "LETTER_IN_SUMMARY" || letter.internalStatus === "LETTER_SUMMARIZED") &&
                                                <Button type="default" icon={<EditFilled />} size="large" shape="circle" onClick={openEditSenderModal} />
                                            }
                                        </Col>
                                        <Col span={8}>
                                            <div className="avatar-info">
                                                <p>{moment.utc(letter.originalLetter.metaData.created).format("DD-MM-yyyy HH:mm (UTC)")}</p>
                                                
                                                <p>
                                                    <Tag  color="blue">{isUrduLanguage ? <span style={{verticalAlign: "sub", height: "25px"}} className={"arabic-font arabic-font-extra-small"}>{getTopicsLabelUrdu(letter.originalLetter.category)}</span> : getTopicsLabel(letter.originalLetter.category)}</Tag>
                                                    <Tag  color="gold">{isUrduLanguage ? <span style={{verticalAlign: "sub", height: "25px"}} className={"arabic-font arabic-font-extra-small"}>{getLanguagesLabel(letter.originalLetter.language)}</span> : getLanguagesLabel(letter.originalLetter.language)}</Tag>
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Divider />
                                </div>
                                </>
                                    }
                                />
                                    <p className={isUrduRTL ? "arabic-font" : "roman-font"} >{letter.originalLetter.content}</p>
                                    <div className="card-bottom-area" style={{position: "absolute", bottom: 5, width: "95%"}}>
                                        <Divider />
                                        <Row>
                                            <Col span={8}>
                                                <div>
                                                    <h4>Address</h4>
                                                    <p>{letter.originalLetter.sender.firstName && letter.originalLetter.sender.lastName ? <>{letter.originalLetter.sender.firstName} {letter.originalLetter.sender.lastName}<br/></> : <><br/></>}
                                                    {letter.originalLetter.sender.streetLine1 ? <>{letter.originalLetter.sender.streetLine1}<br/></> : <><br/></>}
                                                    {letter.originalLetter.sender.streetLine2 ? <>{letter.originalLetter.sender.streetLine2}<br/></> : <><br/></>}
                                                    {letter.originalLetter.sender.zipCode && letter.originalLetter.sender.city ? <>{letter.originalLetter.sender.zipCode} {letter.originalLetter.sender.city}<br/></> : <><br/></>}
                                                    {letter.originalLetter.sender.state ? <>{letter.originalLetter.sender.state}<br/></> : <><br/></>}
                                                    {letter.originalLetter.sender.country?.defaultLabel ? <>{letter.originalLetter.sender.country.defaultLabel}</> : <><br/></>}
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col span={8}>
                                                {letter.originalLetter.customAddress && (
                                                    <div>
                                                        <h4>Custom Address</h4>
                                                        <p>{letter.originalLetter.customAddress?.nameLine ? <>{letter.originalLetter.customAddress.nameLine}<br/></> : <><br/></>}
                                                        {letter.originalLetter.customAddress?.streetLine1 ? <>{letter.originalLetter.customAddress.streetLine1}<br/></> : <><br/></>}
                                                        {letter.originalLetter.customAddress?.streetLine2 ? <>{letter.originalLetter.customAddress.streetLine2}<br/></> : <><br/></>}
                                                        {letter.originalLetter.customAddress?.zipCode && letter.originalLetter.customAddress?.city ? <>{letter.originalLetter.customAddress.zipCode} {letter.originalLetter.customAddress.city}<br/></> : <><br/></>}
                                                        {letter.originalLetter.customAddress?.state ? <>{letter.originalLetter.customAddress.state}<br/></> : <><br/></>}
                                                        {letter.originalLetter.customAddress?.country ? <>{getCountryLabel(letter.originalLetter.customAddress.country)}</> : <><br/></>}
                                                        </p>
                                                    </div>
                                                )}
                                            </Col>
                                            <Col span={8}>
                                                <div>
                                                    <h4>Contact Information</h4>
                                                    <p>Email: {letter.originalLetter.sender.email}<br/>
                                                    Phone: {letter.originalLetter.sender.contactNumber}</p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                    </Card>
                </div>
                <EditSenderDialog showModal={showEditSenderModal} onHideModal={hideEditSenderModal} letter={letter} onSenderUpdateDone={onSenderUpdateDone} />
            </Col>
            <Col span={12}>
                    <div style={{height: "100%"}}>
                        <Card style={{height: "100%", position: "relative", paddingBottom: isReviewMode ? "16px" : "80px"}}>
                                {getStackControls(stack)}
                                {!isReviewMode && (
                                <div className="card-bottom-area" style={{position: "absolute", bottom: 5, width: "95%"}}>
                                    <Divider />
                                    <div>
                                        <Row style={{display: "flex", justifyContent: "space-between"}}>
                                            <Col span={12}>
                                                <b>Created:</b> {letter.createdByName} ({moment.utc(letter.created).format("DD-MM-yyyy HH:mm (UTC)")})<br/>
                                                <b>Last Modified:</b> {letter.modifiedByName} ({moment.utc(letter.modified).format("DD-MM-yyyy HH:mm (UTC)")})
                                            </Col>
                                            <Col span={12}>
                                                <Space>
                                                    {/* "Present Letter to Huzoor" moved to the top of the summary controls, before Skip/Save */}
                                                    {letter.internalStatus !== "LETTER_CANCELLED" && 
                                                        <Button danger onClick={() => setCancelModalVisible(true)}>Cancel or Archive Letter</Button>
                                                    }
                                                </Space>
                                            </Col>
                                        </Row>
                                    </div>
                                <Modal
                                    title="Cancel or Archive Letter"
                                    open={cancelModalVisible}
                                    onOk={handleCancelLetter}
                                    onCancel={() => setCancelModalVisible(false)}
                                    okText="Cancel or Archive Letter"
                                    okButtonProps={{ danger: true }}
                                >
                                    <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
                                        <strong>Use cancellation for:</strong>
                                        <ul style={{ marginTop: 8, marginBottom: 0 }}>
                                            <li>Duplicated letters</li>
                                            <li>Nonsense letters</li>
                                            <li>Insulting letters</li>
                                            <li>Letters which can't be processed by the system</li>
                                            <li>Letters which need to be forwarded to other departments</li>
                                        </ul>
                                    </Typography.Paragraph>
                                    <Input.TextArea
                                        rows={4}
                                        placeholder="Enter cancellation reason"
                                        value={cancelComment}
                                        onChange={e => setCancelComment(e.target.value)}
                                    />
                                </Modal>
                                <Modal
                                    title={<span>Present Letter to Huzoor<sup>aa</sup></span>}
                                    open={presentToHudhurModalVisible}
                                    onOk={handlePresentToHudhur}
                                    onCancel={() => setPresentToHudhurModalVisible(false)}
                                    okText="Confirm"
                                    okButtonProps={{ type: "primary" }}
                                >
                                    <Typography.Paragraph>
                                        <strong>Please confirm:</strong>
                                    </Typography.Paragraph>
                                    <Typography.Paragraph type="secondary">
                                        This letter will be removed from this Summary Stack and will be visible only for the Managers under the Section "Letters to Huzoor<sup>aa</sup>". They can print and present it to Huzoor<sup>aa</sup>.
                                    </Typography.Paragraph>
                                    <Typography.Paragraph type="warning" style={{ marginTop: 16 }}>
                                        <strong>Important:</strong> Do not print this letter additionally and present to Huzoor<sup>aa</sup>, this will cause duplicated submission to Huzoor<sup>aa</sup>.
                                    </Typography.Paragraph>
                                </Modal>
                                </div>
                                )}
                        </Card>
                    </div>
            </Col>
        </Row>
    </>
}